import safari from "./Assets/Images/Desert Safari.jpg";
import mangoes from "./Assets/Images/mangoes.jpg";
import sibi from "./Assets/Images/sibi.jpg";
import polo from "./Assets/Images/shindur.jpg";

export const festivalsContentData = [
  {
    heading: "1. Desert Safari Jeep Rally",
    detail:
      "Cholistan Desert Jeep Rally started back in 2005. The event portrays a softer and positive image of Paksitan abroad. The rally covers three districts of Punjab including Rahim Yar Khan, Bahawalnagar and Bahawalpur. The prime objective to hold this event in the majestic desert of Cholistan is to show outside world its history and rich culture and open this area as Winter Tourist Destination.",
    img: safari,
  },
  {
    heading: "2. Mango Festival Mirpurkhas",
    detail:
      "The annual three-day National Mango Fruit Festival held at Mirpurkhas every year. In the festival mangoes from more than 400 orchards of Sindh are displayed. The district is known for its mangoes in the world and has been organising Mango Festival for the past 54 years. Mango is the King of all fruits whose production is higher in Sindh than other provinces. The main purpose of festival is to promote the local production.",
    img: mangoes,
  },
  {
    heading: "3. Sibi Mela",
    detail:
      "Sibi lies 163 Kms. – 3 hrs. drive to the South East of Quetta at the mouth of the famous “Bolan Pass”. Sibi is famous for SIBI MELA, where tribesmen flock from all over Baluchistan, parts of Sind and Punjab with their animals. The salient features of this “Mela” are horse and cattle and cultural shows, tent pegging, camel races, animal markets and exhibitions of handicrafts, tribal dresses and folk dances.",
    img: sibi,
  },
  {
    heading: "4. Shandur Polo Festival",
    detail:
      "Passion for Polo will be the highest on the world’s highest Polo ground. Every year, Shandur (3,734 meters) invites visitors to experience a traditional polo tournament between the teams of Chitral and Gilgit from 7th to 9th July. The festival also includes folk music, folk dance, traditional sports and a camping village is be set up on the Pass. The version of game played at Shandur Top has attained legendary status.",
    img: polo,
  },
];
